<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4>Assignment Upload Page</h4>
          </div>

          <div class="card-body">
            <form [formGroup]="AssignmentUploadForm">
              <div class="row">

                <div class="col-md-3">
                     
                        <label class="Template">Select file to Upload: </label> 
                      </div>
                     
                        <div class="col-md-4">
                          
                      <input [(ngModel)]="FileUpload" [ngModelOptions]="{standalone: true}" type="file"
                        (change)="onfilechange($event)">
                      
                    </div>
                   
                      <div class="col-md-5">
                      <span class="DownloadTemplate"><a target="_blank" href={{excelPath}}>Download
                        Template</a></span>
                      </div>
                      <!-- <div class="col-md-1"></div> -->
                    </div>
                    <div class="clearfix"></div>
                    <br>
                    <div class="row">
                      <div class="col-md-12" style="text-align: center;">
                        <button class="btn-primary1" type="button" (click)="UploadAttachment($event)">Upload</button>
                        <button class="btn-primary1" (click)="Exit()">Exit</button>
                      </div>
                    </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>